import { useState } from "react";

const loadedSrcCache = new Set();

const SmartImageInner = ({
  src,
  alt,
  className = "",
  wrapperClassName = "",
  skeletonClassName = "",
  loading = "lazy",
  fetchPriority = "auto",
  onLoad,
  onError,
  ...props
}) => {
  const [loaded, setLoaded] = useState(() => loadedSrcCache.has(src));
  const [failed, setFailed] = useState(false);

  const handleLoad = (event) => {
    loadedSrcCache.add(src);
    setLoaded(true);
    onLoad?.(event);
  };

  const handleError = (event) => {
    setFailed(true);
    onError?.(event);
  };

  return (
    <div className={`relative overflow-hidden ${wrapperClassName}`}>
      {!loaded && !failed && (
        <div
          className={`absolute inset-0 animate-pulse bg-gray-200 ${skeletonClassName}`}
          aria-hidden="true"
        />
      )}

      <img
        {...props}
        src={src}
        alt={alt}
        loading={loading}
        fetchPriority={fetchPriority}
        decoding="async"
        onLoad={handleLoad}
        onError={handleError}
        className={`${className} ${loaded ? "opacity-100" : "opacity-0"} transition-opacity duration-500`}
      />
    </div>
  );
};

const SmartImage = (props) => <SmartImageInner key={props.src} {...props} />;

export default SmartImage;
